<template>
  <DialogLayout
    :openDialog="open"
    :maxWidth="maxWidth"
    :title="title"
    :btnAlign="btnAlign"
    @close="_dialogAction"
    eager
    :loading="formLoading"
    :cardContentClass="cardContentClass"
    :enableCancel="enableCancel"
    :confirmBtnText="confirmBtnText"
    :cancelBtnText="cancelBtnText"
    :isCancelDelete="isCancelDelete"
  >
    <v-form class="mt-4" :ref="formRef" @submit.prevent>
      <slot></slot>
    </v-form>
  </DialogLayout>
</template>

<script>
import DialogLayout from '@/components/layout/DialogLayout.vue'
export default {
  name: 'FormDialog',
  components: {
    DialogLayout,
  },
  props: {
    formRef: {
      type: String,
      required: true,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    maxWidth: {
      type: Number,
      default: 500,
    },
    btnAlign: {
      type: String,
      default: 'start',
    },
    cardContentClass: {
      type: String,
      default: '',
    },
    enableCancel: {
      type: Boolean,
      required: false,
      default: false,
    },
    confirmBtnText: {
      type: String,
      required: false,
      default: 'confirm',
    },
    cancelBtnText: {
      type: String,
      required: false,
      default: 'cancel',
    },
    disableCloseHide: {
      type: Boolean,
      required: false,
      default: false,
    },
    isCancelDelete: {
      type: Boolean,
      required: false,
      default: false,
    },
    manualError: {
      type: Boolean,
      required: false,
      default: false,
    }
  },
  data: () => ({
    open: false,
    formLoading: false,
    editId: null,
  }),
  methods: {
    show() {
      this.open = true
    },
    hide() {
      this.open = false
      this.formLoading = false
      this.setEditId(null)
    },
    setLoading(loading) {
      this.formLoading = loading
    },
    setEditId(id) {
      this.editId = id
    },
    getEditId() {
      return this.editId
    },
    async resetForm() {
      await this.$refs[this.formRef].reset()
    },

    async _dialogAction(action) {
      if (this.formLoading) {
        this.$store.dispatch('toggleSnack', { message: 'processing' })
        return
      }

      if (action === true) {
        const valid = await this.$refs[this.formRef].validate()
        this.$emit('form-check')
        if (!valid || this.manualError) {
          this.$store.dispatch('toggleSnack', { message: 'required' })
          return
        }

        this.formLoading = true
        this.$emit('submit-clicked', true)
      } else {
        if (!this.disableCloseHide) {
          this.hide()
        }

        this.$emit('close', action)
      }
    },
  },
}
</script>
